import { clsx } from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type OfferV11 } from '@redteclab/api/clients/bully'
import { IconInfo } from '@redteclab/icons'

import { useGetExperiment } from '../../../../../experiments/hooks'
import { EXPERIMENT_NAME_MARKETPLACE_HARMONISATION } from '../../../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../../../experiments/model/EXPERIMENT_VARIATION'
import { useOpenableControls } from '../../../../../generic-hooks'
import { offerAccessorGetVolumePricing } from '../../../../model/offerAccessor/offerAccessorGetVolumePricing'
import { ProductPageVolumePricingModal } from '../../../ProductPageVolumePricingModal/ProductPageVolumePricingModal'

type ProductOfferVolumePricingLabelProps =
  ComponentPropsWithoutRef<'button'> & {
    className?: string
    currentOffer?: OfferV11
  }

export const ProductOfferVolumePricingLabel: FC<
  ProductOfferVolumePricingLabelProps
> = ({ className, currentOffer }) => {
  const volumePrices = offerAccessorGetVolumePricing(currentOffer)
  const { handleClose, handleOpen, isOpen } = useOpenableControls()

  const isMarketplaceHarmonisationEnabled =
    useGetExperiment(EXPERIMENT_NAME_MARKETPLACE_HARMONISATION).variant ===
    EXPERIMENT_VARIATION.V1

  return (
    <>
      <button
        className={clsx(
          'flex items-center rounded-full align-middle text-xs',
          className,
          isMarketplaceHarmonisationEnabled && 'border-none bg-light-tertiary',
        )}
        data-qa-id="product-offer-volume-price-label"
        onClick={handleOpen}
        type="button"
      >
        <FormattedMessage id="volumePricing.otherOffers.label" />
        {volumePrices ? <IconInfo className="ml-1 size-4 shrink-0" /> : null}
      </button>
      {currentOffer && volumePrices ? (
        <ProductPageVolumePricingModal
          isOpen={isOpen}
          onClose={handleClose}
          volumePrices={volumePrices}
        />
      ) : null}
    </>
  )
}
